import { useFormatting } from "@msys/ui";
import { TextField } from "@mui/material";
import type { GridRenderEditCellParams } from "@mui/x-data-grid-premium";
import React from "react";

export const DataGridPriceEditCell = ({
  id,
  field,
  value,
  api,
}: GridRenderEditCellParams) => {
  const { getEditableFloat, getFloat } = useFormatting();

  const [inputValue, setInputValue] = React.useState<string>(() =>
    getEditableFloat(value ?? 0)
  );

  const commit = React.useCallback(
    (str: string) => {
      const parsed = getFloat(str);
      api.setEditCellValue({
        id,
        field,
        value: Number.isNaN(parsed) ? 0 : parsed,
      });
      api.stopCellEditMode({ id, field });
    },
    [id, field, api, getFloat]
  );

  return (
    <TextField
      value={inputValue}
      onChange={e => setInputValue(e.target.value)}
      onBlur={e => commit(e.target.value)}
      onKeyDown={e => {
        if (e.key === "Enter") commit((e.target as HTMLInputElement).value);
        else if (e.key === "Escape")
          api.stopCellEditMode({ id, field, ignoreModifications: true });
      }}
      autoFocus
      size="extra-small"
      variant="outlined"
      sx={{ "& fieldset": { border: "none" } }}
      fullWidth
    />
  );
};
